export default __webpack_public_path__ + "static/media/deauville10.0d1b5c38.jpg";